import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-release-phone-number-dialog',
    styleUrls: ['./release-phone-number-dialog.component.scss'],
    templateUrl: './release-phone-number-dialog.component.html',
    standalone: false
})
export class ReleasePhoneNumberDialogComponent {
   phoneExtensionList: any = [];

   faxExtensionList: any = [];

   form: any;

   constructor(
      private dialogRef: MatDialogRef<ReleasePhoneNumberDialogComponent>,
      @Inject(MAT_DIALOG_DATA) private data: any
   ) {
      this.phoneExtensionList = data.phoneExtensionList;
      this.faxExtensionList = data.faxExtensionList;
   }

   onConfirm(): void {
      this.dialogRef.close(true);
   }

   onCancel(): void {
      this.dialogRef.close(false);
   }
}
